<template>
  <div class="capsuleToyNOTicket">
    <img src="@images/capsuleToyNOTicketConfirm.png" alt="" class="abs capsuleToyNOTicketConfirm" @click="closePop">
  </div>
</template>

<script>
import { closePop } from '@/utils/common'
export default {
  methods: {
    closePop,
  }
}
</script>

<style scoped>
.capsuleToyNOTicket{ width: 681px; height: 508px; background: url(@images/capsuleToyNOTicket.png) no-repeat 0 0;}
.capsuleToyNOTicketConfirm{ top: 337px; left: 162px;}
</style>